import { DefaultLayoutOptions, CustomLayouts, NewLayoutOptions } from './contants';

const getOptionsMapped = (options) => {
  return options.reduce((result, option) => {
    const mappedOption = option.options.map(({ id, label, title }) => ({
      value: id,
      messageDescriptor: label || title,
    }));
    return [...result, ...mappedOption];
  }, []);
};

export const getCustomLayoutOptionsMapped = () => getOptionsMapped([CustomLayouts]);

export const getLayoutOptionsMapped = () => getOptionsMapped(DefaultLayoutOptions);

// TODO: [SPD-19601]: Remove getNewLayoutOptionsMapped when feature flag is removed
export const getNewLayoutOptionsMapped = () => getOptionsMapped(NewLayoutOptions);

// TODO: [SPD-19601]: Remove enableNewLayoutOptions parameter when feature flag is removed
export const getAllLayoutOptionsMapped = (enableNewLayoutOptions = false) => {
  const baseOptions = [...getCustomLayoutOptionsMapped(), ...getLayoutOptionsMapped()];
  return enableNewLayoutOptions ? [...baseOptions, ...getNewLayoutOptionsMapped()] : baseOptions;
};
